// extracted by mini-css-extract-plugin
module.exports = {"fixedTopRight":"FixedTopRight_fixedTopRight__z3enF"};